export default "__VITE_ASSET__RGjw0QlZ__"